import React from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import ScrollToTop from "./components/scrolltotop/ScrollToTop";
import HomeTwo from "./pages/homepages/HomeTwo";
import Error from "./pages/innerpages/Error";

// Import Css Here
import "./assets/scss/style.scss";
import "./App.css";
import ApplyCoordinator from "./pages/innerpages/ApplyCoordinator";
import ApplyFranchise from "./pages/innerpages/ApplyFranchise";
import ViewInvoice from "./pages/ViewInvoice";
import Verify from "./pages/Verify";
import TermsCondition from "./pages/TermsConditions";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import ContactUs from "./pages/innerpages/ContactUs";
import AboutUsThree from "./pages/innerpages/AboutUsThree";
import LoginRegister from "./pages/innerpages/LoginRegister";

// import dotenv from "dotenv";

function App() {
  // dotenv.config();
  return (
    // <Router>
    <HashRouter>
      <ScrollToTop>
        <Routes>
          {/* <Route exact path="/" element={<LandingDemo />} /> */}
          <Route exact path="/" element={<HomeTwo />} />

          <Route path="*" element={<Error />} />
          <Route exact path="/about-us-3" element={<AboutUsThree />} />
          <Route exact path="/apply-coordinator" element={<ApplyCoordinator />} />
          <Route exact path="/apply-franchise" element={<ApplyFranchise />} />
          <Route exact path="/invoice/:invoiceNumber" element={<ViewInvoice />} />
          <Route exact path="/verify/:certno" element={<Verify />} />
          <Route exact path="/verifygst/:certno" element={<Verify />} />
          <Route exact path="/verify" element={<Verify />} />
          <Route exact path="/verifygst" element={<Verify />} />
          <Route exact path="/terms-condition" element={<TermsCondition />} />
          <Route exact path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route exact path="/contact-us" element={<ContactUs />} />
          <Route exact path="/login-register" element={<LoginRegister />} />
        </Routes>
      </ScrollToTop>
    </HashRouter>
    // </Router>
  );
}

export default App;
